document.addEventListener("DOMContentLoaded", () => {
    // Slider 1: Testimonials (Prev/Next buttons)
    const testimonialSlider = document.querySelector('[aria-label="Customer testimonials carousel"]');
    if (testimonialSlider) {
        const track = testimonialSlider.querySelector('.flex.transition-transform');
        if (track) {
            const slides = track.children;
            const prevBtn = testimonialSlider.querySelector('button[aria-label="Previous testimonial"]');
            const nextBtn = testimonialSlider.querySelector('button[aria-label="Next testimonial"]');

            let currentIndex = 0;

            // Optional dots container inside the testimonial slider scope
            const dotsContainer = testimonialSlider.querySelector('.flex.justify-center.gap-2.mt-8');
            /** @type {HTMLButtonElement[]} */
            let dots = [];
            if (dotsContainer) {
                dots = Array.from(dotsContainer.querySelectorAll('button'));
            }

            function updateTestimonialSlider() {
                track.style.transform = `translateX(-${currentIndex * 100}%)`;

                // Update dots UI if they exist
                if (dots.length > 0) {
                    dots.forEach((dot, index) => {
                        if (index === currentIndex) {
                            dot.classList.remove('bg-grey-300', 'w-3', 'hover:bg-grey-400');
                            dot.classList.add('bg-primary-500', 'w-8');
                            dot.setAttribute('aria-current', 'true');
                        } else {
                            dot.classList.remove('bg-primary-500', 'w-8');
                            dot.classList.add('bg-grey-300', 'w-3', 'hover:bg-grey-400');
                            dot.removeAttribute('aria-current');
                        }
                    });
                }
            }

            // Bind dot clicks
            if (dots.length > 0) {
                dots.forEach((dot, index) => {
                    dot.addEventListener('click', () => {
                        currentIndex = index;
                        updateTestimonialSlider();
                    });
                });
            }

            if (prevBtn) {
                prevBtn.addEventListener('click', () => {
                    currentIndex = (currentIndex > 0) ? currentIndex - 1 : slides.length - 1;
                    updateTestimonialSlider();
                });
            }
            if (nextBtn) {
                nextBtn.addEventListener('click', () => {
                    currentIndex = (currentIndex < slides.length - 1) ? currentIndex + 1 : 0;
                    updateTestimonialSlider();
                });
            }

            // Optional auto-play
            setInterval(() => {
                currentIndex = (currentIndex < slides.length - 1) ? currentIndex + 1 : 0;
                updateTestimonialSlider();
            }, 5000);
        }
    }

    // Slider 2: Health indicators (Dots + Swipe)
    const healthSliderDotsContainer = document.getElementById('health-indicators-mobile-dots');
    const healthSliderTrack = document.getElementById('health-indicators-mobile-track');

    if (healthSliderDotsContainer && healthSliderTrack) {
        const dots = Array.from(healthSliderDotsContainer.querySelectorAll('button'));
        const slides = healthSliderTrack.children;
        let currentHealthIndex = 0;

        function updateHealthSlider(index) {
            currentHealthIndex = index;
            healthSliderTrack.style.transform = `translateX(-${index * 100}%)`;

            // Update dots
            dots.forEach((dot, i) => {
                if (i === index) {
                    dot.style.background = 'linear-gradient(135deg, rgb(217, 218, 151) 0%, rgb(168, 205, 161) 100%)';
                    dot.classList.remove('w-3', 'bg-grey-300');
                    dot.classList.add('w-8');
                    dot.setAttribute('aria-current', 'true');
                } else {
                    dot.style.background = '';
                    dot.classList.remove('w-8');
                    dot.classList.add('w-3', 'bg-grey-300');
                    dot.removeAttribute('aria-current');
                }
            });
        }

        // Click events
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => updateHealthSlider(index));
        });

        // Swipe events
        let touchStartX = 0;
        if (healthSliderTrack) {
            let isDown = false;
            let startX;
            let scrollLeft;

            healthSliderTrack.addEventListener('mousedown', (e) => {
                isDown = true;
                healthSliderTrack.classList.add('active');
                startX = e.pageX - healthSliderTrack.offsetLeft;
                scrollLeft = healthSliderTrack.scrollLeft;
            });
            healthSliderTrack.addEventListener('mouseleave', () => {
                isDown = false;
                healthSliderTrack.classList.remove('active');
            });
            healthSliderTrack.addEventListener('mouseup', () => {
                isDown = false;
                healthSliderTrack.classList.remove('active');
            });
            healthSliderTrack.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - healthSliderTrack.offsetLeft;
                const walk = (x - startX) * 2;
                healthSliderTrack.scrollLeft = scrollLeft - walk;
            });
        }
        let touchEndX = 0;

        healthSliderTrack.parentElement.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        healthSliderTrack.parentElement.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }, { passive: true });

        function handleSwipe() {
            const swipeThreshold = 50;
            if (touchEndX < touchStartX - swipeThreshold) {
                // Swipe Left -> Next
                if (currentHealthIndex < slides.length - 1) {
                    updateHealthSlider(currentHealthIndex + 1);
                }
            }
            if (touchEndX > touchStartX + swipeThreshold) {
                // Swipe Right -> Prev
                if (currentHealthIndex > 0) {
                    updateHealthSlider(currentHealthIndex - 1);
                }
            }
        }
    }

    // Slider 3: PDP Categorized Testimonials
    const testimonialTrack = document.getElementById('testimonial-track-pdp');
    const filterBtns = document.querySelectorAll('.filter-btn');
    const dotsContainer = document.getElementById('testimonial-dots-pdp');

    if (testimonialTrack && filterBtns.length > 0) {
        let currentCategory = 'odor';

        function updateSlider() {
            // Filter slides based on category
            const allSlides = Array.from(testimonialTrack.children);

            // Hide/Show slides
            allSlides.forEach((slide) => {
                const htmlSlide = /** @type {HTMLElement} */ (slide);
                if (htmlSlide.getAttribute('data-category') === currentCategory) {
                    htmlSlide.style.display = 'block';
                } else {
                    htmlSlide.style.display = 'none';
                }
            });

            // Update filter buttons UI
            filterBtns.forEach(btn => {
                if (btn.getAttribute('data-category') === currentCategory) {
                    btn.classList.add('bg-[#F6C267]', 'text-[#001F4D]', 'border-[#F6C267]');
                    btn.classList.remove('text-white', 'border-white/30');
                    btn.setAttribute('aria-pressed', 'true');
                } else {
                    btn.classList.remove('bg-[#F6C267]', 'text-[#001F4D]', 'border-[#F6C267]');
                    btn.classList.add('text-white', 'border-white/30');
                    btn.setAttribute('aria-pressed', 'false');
                }
            });
        }

        filterBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                currentCategory = btn.getAttribute('data-category');
                updateSlider();
            });
        });

        // Initial render
        updateSlider();
    }

    // Slider 4: PDP How To Use section is now a static grid in main-pdp.liquid

    // Feature Cards Hover Accordion
    const featureCardsContainer = document.querySelector('.hidden.md\\:flex.gap-4.lg\\:gap-6.mt-8');
    if (featureCardsContainer) {
        const featureCards = Array.from(featureCardsContainer.children);

        featureCards.forEach((card) => {
            card.addEventListener('mouseenter', () => {
                // Remove active classes from all cards
                featureCards.forEach(c => {
                    c.classList.remove('flex-[1.5]');
                    c.classList.add('flex-1');
                    const p = c.querySelector('p');
                    if (p) {
                        p.classList.remove('max-h-40', 'opacity-100');
                        p.classList.add('max-h-0', 'opacity-0');
                    }
                });

                // Add active classes to the hovered card
                card.classList.remove('flex-1');
                card.classList.add('flex-[1.5]');
                const p = card.querySelector('p');
                if (p) {
                    p.classList.remove('max-h-0', 'opacity-0');
                    p.classList.add('max-h-40', 'opacity-100');
                }
            });

            // Optional: When mouse leaves the whole container, revert to first card being active
            // featureCardsContainer.addEventListener('mouseleave', () => { ... })
        });
    }

    // How-To Steps Slider Replacement (Vue.js data binding emulation)
    const howToData = [
        {
            step: "Paso 1",
            title: "Viértelo",
            desc: "Vierte la arena en una caja de arena limpia y desinfectada. Asegúrate de tener 2 pulgadas de profundidad.",
            imgBase: "howto_01",
            color: "#0077ED"
        },
        {
            step: "Paso 2",
            title: "Recoge los Desechos",
            desc: "Recoge los sólidos todos los días, luego mezcla bien los cristales restantes desde el fondo para asegurar la máxima absorción.",
            imgBase: "howto_02",
            color: "#11BCCA"
        },
        {
            step: "Paso 3",
            title: "Reemplaza Mensualmente",
            desc: "Al final del mes, vacía la caja por completo, límpiala con agua tibia y jabón, y vierte una bolsa nueva.",
            imgBase: "howto_03",
            color: "#FF7369"
        }
    ];

    const howToSections = [
        {
            container: document.querySelector('.hidden.md\\:block.relative > div'),
            img: document.querySelector('.hidden.md\\:block.relative img'),
            stepSpan: document.querySelector('.hidden.md\\:block.relative span.tracking-wider'),
            title: document.querySelector('.hidden.md\\:block.relative h3'),
            desc: document.querySelector('.hidden.md\\:block.relative p'),
            dots: Array.from(document.querySelectorAll('.hidden.md\\:block.relative button[aria-label^="Go to step"]')),
            isMobile: false
        },
        {
            container: document.querySelector('.md\\:hidden > .rounded-2xl'),
            img: document.querySelector('.md\\:hidden > .rounded-2xl img'),
            stepSpan: document.querySelector('.md\\:hidden span.tracking-wider'),
            title: document.querySelector('.md\\:hidden h3'),
            desc: document.querySelector('.md\\:hidden p'),
            dots: Array.from(document.querySelectorAll('.md\\:hidden button[aria-label^="Go to step"]')),
            isMobile: true
        }
    ];

    let currentHowToStep = 0;

    /**
     * @param {number} stepIndex 
     */
    function renderHowToStep(stepIndex) {
        if (stepIndex < 0 || stepIndex > 2) return;
        currentHowToStep = stepIndex;
        const data = howToData[stepIndex];

        howToSections.forEach(section => {
            if (!section.container || !section.img || !section.title || section.dots.length === 0 || !data) return;

            /** @type {HTMLElement} */ (section.container).style.backgroundColor = data.color;
            if (section.stepSpan) {
                /** @type {HTMLElement} */ (section.stepSpan).innerText = data.step;
            }
            /** @type {HTMLElement} */ (section.title).innerText = data.title;
            if (section.desc) {
                 /** @type {HTMLElement} */ (section.desc).innerText = data.desc;
            }

            const suffix = section.isMobile ? "_m" : "";
            const imgEl = /** @type {HTMLImageElement} */ (section.img);
            if (imgEl) {
                imgEl.src = `https://res.cloudinary.com/prettylitter/image/upload/w_auto,q_auto,f_auto,dpr_1/homepage_2025_silk/${data.imgBase}${suffix}`;
                imgEl.alt = data.title;
            }

            section.dots.forEach((dot, dotIdx) => {
                if (dotIdx === currentHowToStep) {
                    dot.className = "h-2 rounded-full transition-all duration-300 bg-white w-8";
                } else {
                    dot.className = "h-2 rounded-full transition-all duration-300 bg-white/40 w-2 hover:bg-white/60";
                }
            });
        });
    }

    // Bind dots for How-To
    howToSections.forEach(section => {
        section.dots.forEach((dot, dotIdx) => {
            dot.addEventListener('click', () => renderHowToStep(dotIdx));
        });
    });

    // Optional autoplay
    setInterval(() => {
        let next = currentHowToStep + 1;
        if (next > 2) next = 0;
        // Don't call renderHowToStep if it hasn't properly initialized yet, 
        // but it's bound.
        if (howToSections && howToSections[0] && howToSections[0].container) {
            renderHowToStep(next);
        }
    }, 5000);

    // Why is PrettyLitter Better Accordion 
    const accordionButtons = document.querySelectorAll('button[aria-controls^="accordion-panel"]');

    accordionButtons.forEach(button => {
        button.addEventListener('click', function () {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            const panelId = this.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
            const icon = this.querySelector('img');

            // Close all other panels in current container (Desktop vs Mobile)
            const parentContainer = this.closest('.space-y-0');
            if (parentContainer) {
                const siblingButtons = parentContainer.querySelectorAll('button[aria-controls^="accordion-panel"]');
                siblingButtons.forEach((/** @type {HTMLElement} */ sibBtn) => {
                    if (sibBtn !== this) {
                        sibBtn.setAttribute('aria-expanded', 'false');
                        /** @type {HTMLImageElement | null} */
                        const sibIcon = sibBtn.querySelector('img');
                        if (sibIcon) sibIcon.src = 'https://res.cloudinary.com/prettylitter/image/upload/w_auto,q_auto,f_svg,dpr_1/homepage_2025_silk/icon_plus';
                        const sibPanelId = sibBtn.getAttribute('aria-controls');
                        if (sibPanelId) {
                            const sibPanel = document.getElementById(sibPanelId);
                            if (sibPanel) {
                                sibPanel.classList.remove('max-h-40', 'opacity-100');
                                sibPanel.classList.add('max-h-0', 'opacity-0');
                            }
                        }
                    }
                });
            }

            // Toggle target panel
            if (isExpanded) {
                this.setAttribute('aria-expanded', 'false');
                if (icon) icon.src = 'https://res.cloudinary.com/prettylitter/image/upload/w_auto,q_auto,f_svg,dpr_1/homepage_2025_silk/icon_plus';
                if (panelId && panel) {
                    panel.classList.remove('max-h-40', 'opacity-100');
                    panel.classList.add('max-h-0', 'opacity-0');
                }
            } else {
                this.setAttribute('aria-expanded', 'true');
                if (icon) icon.src = 'https://res.cloudinary.com/prettylitter/image/upload/w_auto,q_auto,f_svg,dpr_1/homepage_2025_silk/icon_minus';
                if (panel) {
                    panel.classList.remove('max-h-0', 'opacity-0');
                    panel.classList.add('max-h-40', 'opacity-100');

                    // Specific fix since the first panel in HTML didn't use the tailwind class toggle on load:
                    if (!panel.classList.contains('transition-all')) {
                        panel.classList.add('transition-all', 'duration-300', 'overflow-hidden');
                    }
                }
            }
        });
    });

    // FAQ Accordion Fix
    const faqButtons = document.querySelectorAll('.faq-accordion-btn');
    faqButtons.forEach(button => {
        button.addEventListener('click', function () {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            const panelId = this.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
            const svg = this.querySelector('svg');

            // Toggle state
            this.setAttribute('aria-expanded', String(!isExpanded));

            if (panel) {
                if (isExpanded) {
                    panel.style.display = 'none';
                } else {
                    panel.style.display = 'block';
                }
            }

            if (svg) {
                if (isExpanded) {
                    svg.style.transform = 'rotate(0deg)';
                } else {
                    svg.style.transform = 'rotate(45deg)';
                }
            }
        });
    });

    // Slider 5: Product Media Slider
    const productTrack = document.getElementById('product-slider-track');
    const productDotsContainer = document.getElementById('product-slider-dots');
    const productPrevBtn = document.getElementById('product-slider-prev');
    const productNextBtn = document.getElementById('product-slider-next');

    if (productTrack) {
        const slides = productTrack.children;
        const dots = productDotsContainer ? Array.from(productDotsContainer.querySelectorAll('button')) : [];
        let currentIndex = 0;

        function updateProductSlider(index) {
            currentIndex = index;
            productTrack.style.transform = `translateX(-${currentIndex * 100}%)`;

            // Update dots
            dots.forEach((dot, i) => {
                if (i === currentIndex) {
                    dot.classList.add('bg-primary-500', 'w-6');
                    dot.classList.remove('bg-white/50');
                } else {
                    dot.classList.remove('bg-primary-500', 'w-6');
                    dot.classList.add('bg-white/50');
                }
            });
        }

        if (dots.length > 0) {
            dots.forEach((dot, index) => {
                dot.addEventListener('click', () => updateProductSlider(index));
            });
        }

        if (productPrevBtn) {
            productPrevBtn.addEventListener('click', () => {
                const nextIndex = (currentIndex > 0) ? currentIndex - 1 : slides.length - 1;
                updateProductSlider(nextIndex);
            });
        }

        if (productNextBtn) {
            productNextBtn.addEventListener('click', () => {
                const nextIndex = (currentIndex < slides.length - 1) ? currentIndex + 1 : 0;
                updateProductSlider(nextIndex);
            });
        }

        // Swipe support
        let touchStartX = 0;
        let touchEndX = 0;

        productTrack.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        productTrack.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            const swipeThreshold = 50;
            if (touchEndX < touchStartX - swipeThreshold) {
                // Next
                const nextIndex = (currentIndex < slides.length - 1) ? currentIndex + 1 : 0;
                updateProductSlider(nextIndex);
            } else if (touchEndX > touchStartX + swipeThreshold) {
                // Prev
                const nextIndex = (currentIndex > 0) ? currentIndex - 1 : slides.length - 1;
                updateProductSlider(nextIndex);
            }
        }, { passive: true });
    }

});
